<template>
  <span
    :aria-label="label || $t.quantity"
    :class="brandClasses.container"
    data-test-id="vf-stepper"
    role="group"
  >
    <base-button
      :aria-disabled="disabled || model <= min"
      :aria-label="`${$t.decrease} ${label || $t.quantity}`"
      :class="[brandClasses.button, { 'bg-grey-90 c-grey-50': disabled || model <= min }]"
      @click="handleClickDecrease"
    >
      <slot name="decrease-icon" :size="iconSize">
        <vf-icon name="minus" :size="iconSize" />
      </slot>
    </base-button>
    <span
      aria-atomic="true"
      aria-live="polite"
      :class="[brandClasses.display, { 'bg-grey-90 c-grey-50': disabled }]"
    >
      {{ model }}
    </span>
    <base-button
      :aria-disabled="disabled || model >= max"
      :aria-label="`${$t.increase} ${label || $t.quantity}`"
      :class="[brandClasses.button, { 'bg-grey-90 c-grey-50': disabled || model >= max }]"
      @click="handleClickIncrease"
    >
      <vf-icon name="plus" :size="iconSize" />
    </base-button>
  </span>
</template>

<script setup lang="ts">
const { min = 1, max = 100, step = 1, disabled } = defineProps<{
  /**
   * Minimum value inclusive
   */
  min?: number
  /**
   * Maximum value inclusive
   */
  max?: number
  /**
   * Step increase/decrease by pressing the buttons
   */
  step?: number
  /**
   * Defines disabled state
   */
  disabled?: boolean
  /**
   * Accessible label for stepper
   */
  label?: string
}>()

const model = defineModel<number>({ default: 1 })

const { brandClasses, iconSize } = useAppConfig().components.vf.stepper

const handleClickDecrease = () => {
  if (disabled || model.value <= min) return
  model.value -= step
}

const handleClickIncrease = () => {
  if (disabled || model.value >= max) return
  model.value += step
}
</script>
